module.exports = __webpack_public_path__ + "img/changeprofilephoto.a4d70a98.png";